import backblazeService from './backblazeService';

class CloudinaryService {
  async uploadImage(file, folder) {
    return backblazeService.uploadImage(file, folder);
  }

  async uploadFile(file, folder) {
    return backblazeService.uploadFile(file, folder);
  }
}

export default new CloudinaryService();
